import React from "react";
import "../../../Tabs.css";

const RemainingDaysBadge = ({ startDate, endDate, status }) => {
  // 광고 진행 상태에 따른 잔여기간 계산 함수
  const calculateRemainingDays = (startDate, endDate, status) => {
    // ✅ 승인 대기중인 경우 먼저 처리
    if (status === "PENDING") {
      return "승인대기중";
    }

    // ✅ 일시정지인 경우 먼저 처리
    if (status === "PAUSED") {
      return "일시정지";
    }

    // ✅ 광고 완료인 경우 먼저 처리
    if (status === "DONE") {
      return "종료";
    }

    // ✅ 반려된 경우 먼저 처리
    if (status === "REJECTED") {
      return "반려";
    }

    if (!startDate || !endDate) return "-";

    // 년월일만 처리 (YYYY-MM-DD 형식)
    const startDateStr = startDate.split("T")[0]; // YYYY-MM-DD
    const endDateStr = endDate.split("T")[0]; // YYYY-MM-DD
    const nowDateStr = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    // 날짜 문자열을 Date 객체로 변환 (자정으로 설정)
    const startMidnight = new Date(startDateStr + "T00:00:00");
    const endMidnight = new Date(endDateStr + "T00:00:00");
    const nowMidnight = new Date(nowDateStr + "T00:00:00");

    // ✅ 시작일과 종료일이 같은 경우 (1일 광고) 특별 처리
    if (startMidnight.getTime() === endMidnight.getTime()) {
      if (nowMidnight < startMidnight) {
        return "D-1"; // 시작 전
      } else if (nowMidnight.getTime() === startMidnight.getTime()) {
        return "D-0"; // 시작일
      } else {
        return "D-0"; // 종료 후
      }
    }

    // ✅ 실제 광고 총 기간 계산 (시작일과 종료일 모두 포함)
    const actualTotalDuration =
      Math.floor((endMidnight - startMidnight) / (1000 * 60 * 60 * 24)) + 1;

    // 광고 시작일 이전 (승인 대기 중이 아닌 경우)
    if (nowMidnight < startMidnight) {
      return `D-${actualTotalDuration}`; // 실제 계산된 기간 사용
    }

    // 광고 시작일 (광고 시작)
    if (nowMidnight.getTime() === startMidnight.getTime()) {
      return `D-${actualTotalDuration}`; // 실제 계산된 기간 사용
    }

    // 광고 진행 중
    if (nowMidnight > startMidnight && nowMidnight < endMidnight) {
      const daysFromStart = Math.floor(
        (nowMidnight - startMidnight) / (1000 * 60 * 60 * 24)
      );
      const remainingDays = actualTotalDuration - daysFromStart;
      return `D-${remainingDays}`;
    }

    // 광고 마감일
    if (nowMidnight.getTime() === endMidnight.getTime()) {
      return "D-0";
    }

    // 광고 종료 후
    if (nowMidnight > endMidnight) {
      return "종료";
    }
  };

  // 광고 진행 상태에 따른 스타일 클래스
  const getRemainingClass = (startDate, endDate, status) => {
    // ✅ 승인 대기중인 경우 특별한 스타일
    if (status === "PENDING") {
      return "remaining-pending"; // 승인 대기중 전용 스타일
    }

    // ✅ 일시정지인 경우 특별한 스타일
    if (status === "PAUSED") {
      return "remaining-paused"; // 일시정지 전용 스타일
    }

    // ✅ 광고 완료인 경우 특별한 스타일
    if (status === "DONE") {
      return "remaining-expired"; // 광고 완료 전용 스타일 (빨간색)
    }

    // ✅ 반려된 경우 특별한 스타일
    if (status === "REJECTED") {
      return "remaining-rejected"; // 반려 전용 스타일 (분리된 CSS)
    }

    if (!startDate || !endDate) return "remaining-normal";

    // 년월일만 처리 (YYYY-MM-DD 형식)
    const startDateStr = startDate.split("T")[0]; // YYYY-MM-DD
    const endDateStr = endDate.split("T")[0]; // YYYY-MM-DD
    const nowDateStr = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    // 날짜 문자열을 Date 객체로 변환 (자정으로 설정)
    const startMidnight = new Date(startDateStr + "T00:00:00");
    const endMidnight = new Date(endDateStr + "T00:00:00");
    const nowMidnight = new Date(nowDateStr + "T00:00:00");

    // ✅ 시작일과 종료일이 같은 경우 (1일 광고) 특별 처리
    if (startMidnight.getTime() === endMidnight.getTime()) {
      if (nowMidnight < startMidnight) {
        return "remaining-normal"; // 시작 전 - 초록색
      } else if (nowMidnight.getTime() === startMidnight.getTime()) {
        return "remaining-warning"; // 시작일 - 주황색
      } else {
        return "remaining-expired"; // 종료 후 - 빨간색
      }
    }

    // ✅ 실제 광고 총 기간 계산 (시작일과 종료일 모두 포함)
    const actualTotalDuration =
      Math.floor((endMidnight - startMidnight) / (1000 * 60 * 60 * 24)) + 1;

    // 광고 시작일 이전
    if (nowMidnight < startMidnight) {
      return "remaining-normal"; // 시작 전 - 초록색
    }

    // 광고 시작일
    if (nowMidnight.getTime() === startMidnight.getTime()) {
      return "remaining-normal"; // 시작일 - 초록색
    }

    // 광고 진행 중
    if (nowMidnight > startMidnight && nowMidnight < endMidnight) {
      const daysFromStart = Math.floor(
        (nowMidnight - startMidnight) / (1000 * 60 * 60 * 24)
      );
      const remainingDays = actualTotalDuration - daysFromStart;

      // D-4 이상이면 초록색, D-3 이하면 주황색
      if (remainingDays >= 4) {
        return "remaining-normal"; // 초록색
      } else {
        return "remaining-warning"; // 주황색
      }
    }

    // 광고 마감일
    if (nowMidnight.getTime() === endMidnight.getTime()) {
      return "remaining-warning"; // 마감일 - 주황색
    }

    // 광고 종료 후
    if (nowMidnight > endMidnight) {
      return "remaining-expired"; // 종료 후 - 빨간색
    }
  };

  return (
    <span
      className={`status-badge ${getRemainingClass(
        startDate,
        endDate,
        status
      )}`}
    >
      {(() => {
        const result = calculateRemainingDays(startDate, endDate, status);
        return result;
      })()}
    </span>
  );
};

export default RemainingDaysBadge;
